module.exports = __webpack_public_path__ + "79f3ca7f62beabe7186d0beacbc821e9.jpg";